module.exports = __webpack_public_path__ + "img/78WestVineSt_Small.4fa59804.png";